import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { User, UserCreate } from '../../../interfaces/User/UserWMS'

export const putUserWMS = (user: User) => {
  const url = new URL(`${ApiConfig.UserApi}/${user.userId}`)
  return axios.put(url.toString(), user)
}

export const postUserWMS = (user: UserCreate) => {
  const url = new URL(`${ApiConfig.UserApi}`)
  return axios.post(url.toString(), user)
}

export const getUsersWMS = (page = 0, pageSize = 10, email?: string, userId?: string, active?: string) => {
  const url = new URL(`${ApiConfig.UserApi}`)
  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (email) url.searchParams.set('email', email)
  if (userId) url.searchParams.set('userId', userId)
  if (active) url.searchParams.set('active', active)

  // omite los usuarios de intergración
  url.searchParams.set('excludeUserIntegration', 'true')

  return axios.get(url.toString())
}

export const getUserWMS = (id: number) => {
  const url = new URL(`${ApiConfig.UserApi}/${id}`)
  return axios.get(url.toString())
}
